/**
 * The landing page is rendered once per "track" — the language a visitor wants
 * to learn. Both tracks share one layout; everything that differs between them
 * is either copy (which lives in the translation files under `keyPrefix`) or
 * one of the few structural switches below.
 *
 * Note that a track is not a UI locale. The UI locale is what language the site
 * is *read* in, and is handled by LanguageSwitcher. A Vietnamese speaker living
 * in Denmark may well read the site in Vietnamese while learning Danish.
 */
export type Track = 'danish' | 'english';

export interface TrackConfig {
  /** Prefix for this track's copy in public/locales/<lng>/translation.json */
  keyPrefix: 'landing' | 'landingEnglish';
  /** Canonical route for this track */
  path: string;
  /** Route of the other track, linked from the header */
  otherTrackPath: string;
  /**
   * Testimonials are shown only where real, attributable quotes exist. The
   * English track has none yet, so it renders without the section rather than
   * with invented ones.
   */
  showTestimonials: boolean;
}

export const TRACKS: Record<Track, TrackConfig> = {
  danish: {
    keyPrefix: 'landing',
    path: '/',
    otherTrackPath: '/learn-english',
    showTestimonials: true,
  },
  english: {
    keyPrefix: 'landingEnglish',
    path: '/learn-english',
    otherTrackPath: '/',
    showTestimonials: false,
  },
};
